<template>
    <div class="relative">
        <Tabs :tabs="tabs" tab-margin-right="16" initial-tab="tab1">
            <template v-slot:tab1>
                <div class="flex" v-if="edit">
                    <div class="flex-1">
                        <div class="mr-5 mb-2 flex-1">
                            <div class="text-xs text-gray pb-1">Подразделение</div>
                            <dropdown v-model="department" :options="departmentStore.departments">
                                {{ scheduleStore.cutStr(department.name, 23) }}
                            </dropdown>
                        </div>
                        <div class="mr-5 mb-2 flex-1">
                            <div class="text-xs text-gray pb-1">Должность</div>
                            <dropdown v-model="position" :options="scheduleStore.positions">
                                {{ scheduleStore.cutStr(position.name, 23) }}
                            </dropdown>
                        </div>

                        <div class="mr-5 mb-2 flex-1">
                            <div class="text-xs text-gray pb-1">Дата начала</div>
                            <AppDateInput v-model="date" />
                        </div>

                        <div class="mr-5 mb-2 flex-1">
                            <div class="text-xs text-gray pb-1">Дата окончания</div>
                            <AppDateInput v-model="firedDate" />
                        </div>

                    </div>
                    <div class="flex-1">
                        <div class="mr-5 mb-2 flex-1">
                            <base-input v-model="percentage" max-length="3" @input="onPercentageInput" class="mb-1">Доля рабочих часов</base-input>
                        </div>
                        <div class="mr-5 mb-2 flex-1">
                            <div class="text-xs text-gray pb-1">Доступность</div>
                            <dropdown v-model="shiftSchedule" :options="scheduleStore.shiftSchedules">
                                {{ shiftSchedule.name }}
                            </dropdown>
                        </div>
                    </div>
                </div>
                <div class="flex" v-else>
                    <div class="flex-1">
                        <EmployeeDataItem label="Подразделение" :value="department.name" v-if="department.name" />
                        <EmployeeDataItem label="Должность" :value="position.name" v-if="position" />
                        <EmployeeDataItem label="Дата начала" :value="hired" />
                        <EmployeeDataItem label="Дата окончания" :value="fired" />
                    </div>
                    <div class="flex-1">
                        <EmployeeDataItem label="Доля рабочих часов" :value="percent" />
                        <EmployeeDataItem label="Доступность" :value="availability" />
                    </div>
                </div>
                <div class="pt-3 text-right" v-if="edit">
                    <btn @click="save" :disabled="isDisabled" :class="{ 'opacity-50': isDisabled }">Сохранить</btn>
                    <btn class="ml-3" type="secondary" @click="cancel">Отмена</btn>
                </div>
            </template>
        </Tabs>
        <div v-if="!edit" class="absolute right-0 top-8 text-xs cursor-pointer text-graylight" @click="change">
            Изменить
        </div>
        
    </div>
</template>

<script setup lang="ts">
import Tabs from '../Tabs.vue'
import EmployeeDataItem from './EmployeeDataItem.vue'
import { computed, ref } from 'vue'
import { Option } from '@/types'
import dayjs from 'dayjs'
import AppDateInput from '@/ui/AppDateInput.vue'
import { useScheduleStore } from '@/stores/scheduleStore'
import { useDepartmentStore } from '@/stores/departmentStore'
import { useEmploymentStore } from '@/stores/employmentStore'

interface Props {
    employment: any
}

interface Tab {
    name: string,
    label: string
}

const scheduleStore = useScheduleStore()
const departmentStore = useDepartmentStore()
const employmentStore = useEmploymentStore()

const tabs: Tab[] = [
    { name: 'tab1', label: 'Трудоустройство' }
    // { name: 'tab2', label: 'Активность' },
    // { name: 'tab3', label: 'Документы' },
    // { name: 'tab4', label: 'Smart Scheduling' },
    // { name: 'tab5', label: 'Настройки' }
]

const { employment } = defineProps<Props>()
const emit = defineEmits(['cancel'])
const edit = ref(false)
const isDisabled = ref(false)
const percentage = ref(employment.percentage * 100 + '')
const hired = computed(() => dayjs(employment.hired_at).format('DD.MM.YYYY'))
const fired = computed(() => employment.fired_at ? dayjs(employment.fired_at).format('DD.MM.YYYY') : '-')
const availability = computed(() => 
    employment.shift_schedule ?
    scheduleStore.shiftSchedules.find(item => item.id === employment.shift_schedule).name : ''
)
const percent = computed(() => employment.percentage * 100 + '%')

const position = ref<Option>({ id: employment.position, name: scheduleStore.positions.find(item => item.id === employment.position)?.name! })
const department = ref<Option>({ id: employment.department, name: departmentStore.departments.find(item => item.id === employment.department)?.name! })
const shiftSchedule = ref<Option>({ id: employment.shift_schedule, name: scheduleStore.shiftSchedules.find(item => item.id === employment.shift_schedule)?.name! })
const date = ref(dayjs(employment.hired_at))
const firedDate = ref(employment.fired_at ? dayjs(employment.fired_at) : undefined)

const change = () => {
    edit.value = true
}

const cancel = async () => {
    edit.value = false
    emit('cancel')
}

const save = async () => {
    let fired = (firedDate.value) ? dayjs(firedDate.value).toISOString() : null
    let data = {
        department: department.value.id,
        position: position.value.id,
        percentage: +percentage.value/100,
        shift_schedule: shiftSchedule.value.id,
        hired_at: dayjs(date.value).toISOString(),
        fired_at: fired
    }
    
    await employmentStore.changeEmployment(employment.id, data)
    await employmentStore.fetchEmployment(employment.id)
    edit.value = false
}

const onPercentageInput = () => {
    percentage.value = percentage.value.replace(/\D/g, '');
}
</script>



